import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { PixelEvent } from '@models/pixel.model';

@Injectable({
  providedIn: 'root'
})
export class MarketingService {

  private URL: string = environment.rootUrl;

  constructor(
    private http: HttpClient,
  ) { }

  public pixelCall(pixelEvent: PixelEvent): Promise<object> {
    return lastValueFrom(this.http.post<PixelEvent>(`${this.URL}/meta/data`, pixelEvent));
  }
}
